<h2>Componente de edición y creado de nodos</h2>

<div *ngIf="editingMode === EditingMode.Off">
  <p>Seleccione la operación que desea realizar en el menú de la izquierda</p>
</div>
<!-- Edición y Creación de nodo -->
<!-- <div *ngIf="editingMode === EditingMode.Update"> -->
<div *ngIf="editingMode !== EditingMode.Delete">
  <div>
    <mat-error *ngIf="errorValidacionCreacionNodo"
      ><b>Error de validación.</b>
      <p>Por favor, asegúrese de ingresar todos los campos obligatorios</p>
    </mat-error>
  </div>
  <!-- Código para edición de 'FORMULARIO', 'CHAT', 'ACCIÓN', 'PREGUNTA', 'RESPUESTA' -->
  <div
    *ngIf="
      node &&
      (node.type === NodeType.Chat ||
        node.type === NodeType.Form ||
        node.type === NodeType.Action ||
        node.type === NodeType.Question ||
        node.type === NodeType.Response ||
        node.type === NodeType.Tramite ||
        node.type === NodeType.Enlace)
    "
  >
    <div>
      <mat-error *ngIf="parent && parent.type === NodeType.Tramite">
        <p>
          Para nodo de tipo trámite únicamente se pueden crear nodos hijos de
          tipo Respuesta no visibles.
        </p>
      </mat-error>
    </div>

    <mat-form-field
      style="width: 350px"
      appearance="fill"
      *ngIf="
        editingMode === EditingMode.Create &&
        parent &&
        parent.type !== NodeType.Tramite
      "
    >
      <mat-label>Tipo de nodo</mat-label>
      <mat-select
        (selectionChange)="emptyValues()"
        [(ngModel)]="nodeType"
        name="type"
        required
      >
        <mat-option *ngFor="let type of nodeTypes" [value]="type">
          {{ type }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="fill"
      *ngIf="
        editingMode === EditingMode.Update ||
        (parent && parent.type === NodeType.Tramite)
      "
      class="readonly-field"
      matTooltip="Este campo no es editable"
    >
      <mat-label>Tipo de Nodo</mat-label>
      <input matInput [value]="nodeType" readonly />
    </mat-form-field>

    <mat-form-field class="form-full-width" appearance="fill">
      <mat-label>Etiqueta</mat-label>
      <input
        matInput
        placeholder="Etiqueta"
        [(ngModel)]="name"
        required
        maxlength="250"
      />
    </mat-form-field>

    <mat-form-field
      class="form-full-width"
      *ngIf="nodeType == NodeType.Enlace"
      appearance="fill"
    >
      <mat-label>URL</mat-label>
      <input
        matInput
        placeholder="URL"
        [(ngModel)]="url"
        required
        maxlength="500"
      />
    </mat-form-field>

    <div
      class="form-field-align"
      *ngIf="parent && parent.type !== NodeType.Tramite"
    >
      <label>Visible</label>
      <mat-slide-toggle [(ngModel)]="visible"></mat-slide-toggle>
    </div>
    <mat-form-field
      appearance="fill"
      *ngIf="parent && parent.type === NodeType.Tramite"
      class="readonly-field"
      matTooltip="Este campo no es editable"
    >
      <mat-label>Visible</mat-label>
      <input matInput [value]="visible ? 'Si' : 'No'" readonly />
    </mat-form-field>

    <div class="form-field-align" *ngIf="nodeType != NodeType.Enlace">
      <label>Requiere autenticación</label>
      <mat-slide-toggle [(ngModel)]="requiereAutenticacion"></mat-slide-toggle>
    </div>
    <mat-form-field
      class="form-full-width"
      appearance="fill"
      *ngIf="nodeType == NodeType.Chat"
    >
      <mat-label>Encolado Máximo</mat-label>
      <input
        matInput
        placeholder="Encolado Máximo"
        [(ngModel)]="encoladoMaximo"
        required
        maxlength="5"
        type="number"
      />
    </mat-form-field>
    <div class="form-field-align" *ngIf="nodeType == NodeType.Chat">
      <label for="habilitado">Reenviar con histórico (*)</label>
      <mat-slide-toggle [(ngModel)]="guardarHistorico"></mat-slide-toggle>
    </div>
    
    <div class="form-field-align" *ngIf="nodeType == NodeType.Chat">
        <label for="requiereEncuesta">Requiere encuesta</label>
        <mat-slide-toggle
          [(ngModel)]="requiereEncuesta"
        ></mat-slide-toggle>
    </div>

    <mat-form-field
      class="form-full-width"
      appearance="fill"
      *ngIf="nodeType == NodeType.Chat && requiereEncuesta"
    >
      <mat-label>Código de encuesta</mat-label>
      <input
        matInput
        placeholder="Código de encuesta"
        [(ngModel)]="codigoEncuesta"
        required
        maxlength="15"
        type="text"
      />
    </mat-form-field>

    <div
      class="form-field-align"
      *ngIf="
        (editingMode == EditingMode.Update &&
          node.type === NodeType.Response) ||
        (editingMode == EditingMode.Create && nodeType == NodeType.Response)
      "
    >
      <label>Contenido de Innova</label>
      <mat-slide-toggle
        [(ngModel)]="contenidoInnova"
        (change)="onContenidoInnovaChange()"
      ></mat-slide-toggle>
    </div>

    <mat-form-field
      class="form-full-width"
      appearance="fill"
      *ngIf="
        (contenidoInnova &&
          ((editingMode == EditingMode.Update &&
            node.type === NodeType.Response) ||
            (editingMode == EditingMode.Create &&
              nodeType == NodeType.Response))) ||
        (editingMode == EditingMode.Update && node.type === NodeType.Tramite) ||
        (editingMode == EditingMode.Create && nodeType == NodeType.Tramite)
      "
    >
      <mat-label>ID Contenido</mat-label>
      <input
        matInput
        placeholder="ID Contenido"
        [(ngModel)]="idContenido"
        required
        maxlength="250"
      />
    </mat-form-field>

    <mat-form-field
      class="form-full-width"
      appearance="fill"
      *ngIf="
        (editingMode == EditingMode.Update && node.type === NodeType.Action) ||
        (editingMode == EditingMode.Create && nodeType == NodeType.Action)
      "
    >
      <mat-label>Código de Asistencia</mat-label>
      <input
        matInput
        placeholder="Código de Asistencia"
        [(ngModel)]="codigoAsistenteAccion"
        required
        maxlength="60"
      />
    </mat-form-field>

    <quill-editor
      *ngIf="
        !contenidoInnova &&
        ((editingMode == EditingMode.Update &&
          node.type === NodeType.Response) ||
          (editingMode == EditingMode.Create && nodeType == NodeType.Response))
      "
      [(ngModel)]="answer"
      [modules]="editorOptions.modules"
      (onContentChanged)="textChanged($event)"
    ></quill-editor>
    <br />

    <mat-form-field style="width: 350px" appearance="fill">
      <mat-label>Posición nodo</mat-label>
      <mat-select [(ngModel)]="position" name="pos" required>
        <mat-option
          *ngFor="let pos of numberOfSiblingsArrCreation"
          [value]="pos"
        >
          {{ pos }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div
      *ngIf="
        node?.type != NodeType.Enlace &&
        nodeType != NodeType.Enlace &&
        nodeType != NodeType.Action &&
        node?.type != NodeType.Action
      "
    >
      <br />
      <h4>Vías de contacto</h4>
      <mat-form-field
        style="width: 350px"
        appearance="fill"
        *ngIf="
          (editingMode == EditingMode.Update && node.type === NodeType.Tramite) ||
          (editingMode == EditingMode.Create && nodeType == NodeType.Tramite) ||
          (editingMode == EditingMode.Update && node.type === NodeType.Question) ||
          (editingMode == EditingMode.Create && nodeType == NodeType.Question) ||
          (editingMode == EditingMode.Update && node.type === NodeType.Response) ||
          (editingMode == EditingMode.Create && nodeType == NodeType.Response)
        "
      >
        <mat-label>Tipo de vinculación</mat-label>
        <mat-select
          [(ngModel)]="tipoVinculacion"
          (selectionChange)="onTipoVinculacionChange($event.value)"
        >
          <mat-option
            *ngFor="let pos of optionsTipoVinculacion"
            [value]="pos.value"
          >
            {{ pos.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="sinDestinatarios" class="alert">
        Este menú no tiene destinatario asociado. Para poder crear este nodo,
        debe asociar algún destinatario de este tipo previamente.
      </div>
      <mat-form-field
        style="width: 650px"
        appearance="fill"
        *ngIf="tipoVinculacion == '0' && !sinDestinatarios"
      >
        <mat-label>Destinatario</mat-label>
        <mat-select
          [(ngModel)]="destinatarioSeleccionado"
          (selectionChange)="onDestinatarioChange($event.value)"
          name="temaDestinatario"
        >
          <mat-option
            *ngFor="let temaDestinatario of destinatariosMenuDisponibles"
            [value]="temaDestinatario"
          >
            <div *ngIf="temaDestinatario.destinatario.habilitado">
              {{ temaDestinatario.destinatario.titulo }}
            </div>
            <div
              *ngIf="!temaDestinatario.destinatario.habilitado"
              style="color: #9c9797"
            >
              {{ temaDestinatario.destinatario.titulo }} - Deshabilitado
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <ng-container
      *ngIf="
        tipoVinculacion == '1' &&
        (
          (editingMode == EditingMode.Update && (node.type === NodeType.Tramite || node.type === NodeType.Question || node.type === NodeType.Response)) ||
          (editingMode == EditingMode.Create && (nodeType == NodeType.Tramite || nodeType == NodeType.Question || nodeType == NodeType.Response))
        )
      "
      >
        <mat-form-field class="form-full-width" appearance="fill">
          <mat-label>Código de Asistencia</mat-label>
          <input
            matInput
            placeholder="Código de Asistencia"
            [(ngModel)]="codigoAsistenteAccion"
            maxlength="60"
          />
        </mat-form-field>
      </ng-container>

      <ng-container
        *ngIf="
          tipoVinculacion == '0' &&
          destinatarioSeleccionado &&
          destinatarioSeleccionado.destinatario?.id !== null
        "
      >
        <mat-form-field style="width: 350px" appearance="fill">
          <mat-label>Tipo formulario</mat-label>
          <mat-select [(ngModel)]="tipoFormulario" required>
            <mat-option
              *ngFor="let pos of optionsTipoFormulario"
              [value]="pos.value"
            >
              {{ pos.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="form-full-width" appearance="fill">
          <mat-label>Tema</mat-label>
          <input
            matInput
            placeholder="Tema"
            [(ngModel)]="temaMotivo"
            required
            maxlength="250"
          />
        </mat-form-field>
      </ng-container>

      <div
        class="contenedor_tabla"
        style="
          width: 98%;
          height: auto;
          padding-top: 30px;
          padding-bottom: 30px;
        "
        *ngIf="tipoVinculacion == '0'"
      >
        <h4>Validaciones</h4>

        <mat-table
          #table
          [dataSource]="dataSource"
          matSort
          class="mat-elevation-z8"
        >
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef class="column-width-50">
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              >
              </mat-checkbox>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              class="column-width-50"
              [ngStyle]="
                element.habilitado
                  ? { 'background-color': 'rgb(240 243 243)' }
                  : { 'background-color': 'rgba(0,0,0,.12)' }
              "
            >
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(element) : null"
                [checked]="selection.isSelected(element)"
              >
              </mat-checkbox>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nombre">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Nombre de validación
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              [ngStyle]="
                element.habilitado
                  ? { 'background-color': 'rgb(240 243 243)' }
                  : { 'background-color': 'rgba(0,0,0,.12)' }
              "
            >
              {{ element.nombre }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="tipo">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Tipo de validación
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              [ngStyle]="
                element.habilitado
                  ? { 'background-color': 'rgb(240 243 243)' }
                  : { 'background-color': 'rgba(0,0,0,.12)' }
              "
            >
              {{ element.tipo.nombre }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="habilitado">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="textoCentradoTabla column-width-150"
            >
              Habilitado
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              class="textoCentradoTabla column-width-150"
              [ngStyle]="
                element.habilitado
                  ? { 'background-color': 'rgb(240 243 243)' }
                  : { 'background-color': 'rgba(0,0,0,.12)' }
              "
            >
              {{ element.habilitado ? "Si" : "No" }}
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <mat-paginator
          [length]="100"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 25, 100]"
        >
        </mat-paginator>
      </div>
      <div
        class="contenedor_tabla"
        style="
          width: 98%;
          height: auto;
          padding-top: 10px;
          padding-bottom: 10px;
        "
        *ngIf="editingMode == EditingMode.Update"
      >
        <ng-container>
          <span class="padding-right-10">
            <button mat-raised-button color="primary" (click)="generarURL()">
              Generar URL
            </button>
          </span>
          <mat-form-field
            appearance="fill"
            *ngIf="mostrarURL"
            class="readonly-field labelUrl"
            matTooltip="Este campo no es editable"
          >
            <mat-label>URL</mat-label>
            <input matInput [value]="urlNodo" readonly />
          </mat-form-field>
        </ng-container>
      </div>

      <br />
    </div>
  </div>

  <!-- Código para preguntas frecuentas (FAQS) -->
  <!-- Caso Nodo FAQ -->
  <div *ngIf="typeFaq" style="overflow: scroll; height: 70vh">
    <h2>Qué preguntas desea designar como frecuentes?</h2>
    <div
      *ngFor="let faq of possibleFaqs"
      style="margin-bottom: 10px; width: 95%"
    >
      <mat-card>
        <mat-checkbox
          (change)="toggleSelection($event, faq)"
          [checked]="selection.isSelected(faq)"
        ></mat-checkbox>
        <span style="padding-left: 10px">{{ faq.nombre }}</span>
        <span style="padding-left: 10px">{{ "( " + faq.path + " )" }}</span>
      </mat-card>
    </div>
  </div>

  <div *ngIf="typeFaq" style="padding-bottom: 10px; padding-top: 20px">
    <span class="padding-right-10">
      <button mat-raised-button color="primary" (click)="createNode()">
        Asignar preguntas frecuentes
      </button>
    </span>
    <span class="padding-right-10">
      <button mat-raised-button (click)="cancelOperation()">Cancelar</button>
    </span>
  </div>

  <span
    class="padding-right-10"
    *ngIf="editingMode == EditingMode.Create && !typeFaq"
  >
    <button mat-raised-button color="primary" (click)="createNode()">
      Crear Nodo
    </button>
  </span>

  <span
    class="padding-right-10"
    *ngIf="editingMode == EditingMode.Update && !typeFaq"
  >
    <button mat-raised-button color="primary" (click)="applyOperation()">
      Aplicar cambios
    </button>
  </span>

  <span
    class="padding-right-10"
    *ngIf="
      (editingMode == EditingMode.Create ||
        editingMode == EditingMode.Update) &&
      !typeFaq
    "
  >
    <button mat-raised-button (click)="cancelOperation()">Cancelar</button>
  </span>
</div>

<!-- Eliminación de nodo -->
<div *ngIf="editingMode === EditingMode.Delete">
  <mat-error *ngIf="referenciadoEnFAQ">
    <b>El nodo está referenciado en alguna pregunta frecuente.</b>
  </mat-error>

  <p>{{ "Seguro que desea eliminar el nodo" }}</p>
  <p>{{ this.node.name + "?" }}</p>

  <span class="padding-right-10">
    <button mat-raised-button (click)="deleteNode()" color="warn">
      Eliminar
    </button>
  </span>

  <span class="padding-right-10">
    <button mat-raised-button (click)="cancelOperation()">Cancelar</button>
  </span>
</div>

<div class="spinner-overlay" *ngIf="loading">
  <div class="spinner-center">
    <mat-spinner *ngIf="loading" diameter="80" color="primary"></mat-spinner>
    <label class="input-label" *ngIf="loading">&nbsp; Cargando datos...</label>
  </div>
</div>
